/**
 * 获取指定Url参数的方法
 * @param url 完整路径
 * @param paraName 获取的url参数
 * @return {String} 具体值 无则返回 “”
 */
export const getUrlParam = function (url, paraName = "") {
  let path = url;
  let arrObj = path.split("?");
  if (arrObj.length > 1) {
    let arrPara = arrObj[1].split("&");
    let arr;
    for (let i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split("=");
      if (arr != null && arr[0] === paraName) {
        return arr[1];
      }
    }
    return "";
  } else {
    return "";
  }
};
